export const isColumn = (x) => {
    if (x === undefined) {
        return false;
    }
    if (x.type === undefined) {
        return "column" in x && Object.keys(x).length === 1;
    }
    return x.type === "column";
};
export const isNotColumn = (x) => {
    return !isColumn(x);
};
export const isInterval = (x) => {
    if (x === undefined) {
        return false;
    }
    if (x.type === undefined) {
        return "column" in x && "start" in x && "end" in x;
    }
    return x.type === "interval";
};
const COLUMN_VALUE_TYPES = {
    ["missing"]: true,
    ["text"]: true,
    ["number"]: true,
    ["interval"]: true
};
export const isColumnValue = (x) => {
    if (x === undefined) {
        return false;
    }
    if (x.type === undefined) {
        return "column" in x && ("value" in x || isInterval(x));
    }
    return x.type in COLUMN_VALUE_TYPES;
};
export class DataProperties {
    static column(column) {
        return {
            type: "column",
            column: column
        };
    }
    static typeFromValue(value) {
        switch (typeof value) {
            case "string":
                return "text";
            case "number":
                return "number";
            case "undefined":
            case "object": // null is object
                return "missing";
        }
    }
    static missing(column) {
        return this.value(column, undefined);
    }
    static value(column, value) {
        switch (typeof value) {
            case "string":
                return {
                    type: "text",
                    column: column,
                    value: value
                };
            case "number":
                return {
                    type: "number",
                    column: column,
                    value: value
                };
            default:
                return {
                    type: "missing",
                    column: column,
                    value: value
                };
        }
    }
    static interval(column, start, end) {
        return {
            type: "interval",
            column: column,
            start: start,
            end: end
        };
    }
    static getValue(columnValue) {
        if (isInterval(columnValue)) {
            return (columnValue.end + columnValue.start) / 2;
        }
        return columnValue.value;
    }
}
export class InsightConditionsBuilder {
    factory;
    state = {};
    constructor(factory) {
        this.factory = factory;
    }
    isValidProperty(property) {
        if (isColumnValue(property)) {
            return this.getCondition(property) !== undefined;
        }
        else if (isColumn(property)) {
            return this.factory.getId(property.column) !== undefined;
        }
        return false;
    }
    addProperty(property) {
        if (isColumnValue(property)) {
            return this.addColumnValue(property);
        }
        else if (isColumn(property)) {
            return this.addColumn(property);
        }
        return this;
    }
    addColumn({ column }) {
        const id = this.factory.getId(column);
        if (id !== undefined) {
            (this.state.ids ??= []).push(id);
        }
        return this;
    }
    addColumnValue(cv) {
        const condition = this.getCondition(cv);
        if (condition !== undefined) {
            (this.state.conditions ??= []).push(condition);
        }
        return this;
    }
    getCondition(cv) {
        return this.factory.getCondition(cv.column, DataProperties.getValue(cv));
    }
    build() {
        return {
            ids: this.state.ids?.slice(),
            conditions: this.state.conditions?.slice()
        };
    }
    clear() {
        this.state = {};
        return this;
    }
}
